<template>
	<select
		class="chosen-select"
		ref="selectElement"
		multiple
		@change="handleChange"
		:data-placeholder="props.placeholder"
	>
		<option v-for="option in props.options" :key="option" :value="option">{{ option }}</option>
	</select>
</template>

<script setup>
import {
	defineModel,
	defineOptions,
	defineProps,
	ref,
	onMounted,
	watch,
	nextTick
} from 'vue';
global.jQuery = require('jquery');
const $ = global.jQuery;
//eslint-disable-next-line no-unused-vars
import chosen from '../../assets/js/chosen.jquery.js';

defineOptions({
	name: 'MultiSelect'
});

const props = defineProps(['placeholder', 'options']);
const selectedOptions = defineModel(); //using a model because changing its value with emit the event to the parent. No need to define the emit events explicitly.
const selectElement = ref(null);

//ensure the chose dropdown is updated when the options prop contains data/is updated
watch(() => props.options, options => { nextTick().then(() => $(selectElement.value).trigger('chosen:updated')); }, { deep: true });

onMounted(() => {
	$(selectElement.value)
		.val(selectedOptions)
		.chosen({ width: '180px' })
		.on('change', () => {
			const selectedValues = $(selectElement.value).val();
			selectedOptions.value = selectedValues;
		});
});
</script>

<style lang="less" scoped>
@import '~_css_/chosen.css';
.chosen-container {
	color: #333;
	font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
	.chosen-choices {
		background-image: none;
		padding: 0;
	}
	.search-choice {
		background-color: #ccc;
		background-image: none;
		border: none;
		border-radius: 0;
		padding: 3px 20px 3px 5px;
		margin: 4px 0 1px 5px;
	}
	.search-field {
		min-height: 25px;
		.default {
			font-family: 'AvenirNextLTW01-Regular', Arial, sans-serif;
			color: #999;
			padding: 5px;
		}
		input {
			height: auto;
			width: auto !important;
		}
	}
}
</style>
